module.exports = __webpack_public_path__ + "caac2edb947dfbf321372bdf2a635a43.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/base/base-20.png
// module id = 1790
// module chunks = 0